<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述： 修改当前账户密码
    -->
	<div class="changepassword">
		<div style="margin: 20px;"></div>
		<el-form :label-position="labelPosition" label-width="80px" :model="changepassword">
			<el-form-item label="旧密码">
				<el-input v-model="changepassword.oldpassword"  placeholder="请输入旧密码" :type="change" style="width:220px;">
				</el-input>
			</el-form-item>
			<el-form-item label="新密码">
				<el-input v-model="changepassword.newpassword"  placeholder="请输入新密码" :type="change" style="width:220px;"></el-input>
			</el-form-item>
			<el-form-item label="确认新密码">
				<el-input v-model="changepassword.turePassword"  placeholder="请确认新密码" :type="change" style="width:220px;"></el-input>
			</el-form-item>
		</el-form>
		<div class="bottom-botton">
			<el-button type="primary" @click="sumbit">确认</el-button>
		</div>
	</div>
</template>-

<script>
	export default {
		data() {
			return {
				labelPosition: 'top',
				changepassword: {
					oldpassword: '',
					newpassword: '',
					turePassword: ''
				},
				change:"password",
			}
		},
		methods: {
			sumbit() {
				let oldpassword = this.changepassword.oldpassword
				let newpassword = this.changepassword.newpassword
				let turepassword = this.changepassword.turePassword
				if(oldpassword == 0){
					return this.$message.warning("请输入旧密码")
				}
				if(newpassword == 0){
					return this.$message.warning("请输入新密码")
				}
				if(turepassword == 0){
					return this.$message.warning("请确认新密码")
				}
				if(newpassword.length < 6){
					return this.$message.warning("新密码不得小于6位")
				}
				if(newpassword.length > 12){
					return this.$message.warning("新密码不得超过12位")
				}
				if(newpassword === oldpassword){
					this.changepassword.newpassword = ''
					this.changepassword.turePassword = ''
					return this.$message.warning("不能使用同一个密码")
				}
				if(newpassword != turepassword){
					this.changepassword.turePassword = ''
					return this.$message.warning("两次密码不一致")
					
				}
				this.$jssdk.member.editPassword(this.changepassword, (data) => {
					this.$message({
						type:'success',
						message:'修改成功请从新登录',
						duration:1000
					})
					this.$router.push({
						name: "SignIn",
					})
					return
				}, (err) => {
					return this.$message({
						type:'success',
						message:err.msg,
						duration:1000
					})
				})
			}
		},
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// ChangePassword.vue?2c7ab074